<form class="fix-editor numeric-cell-editor">
    <ng-container *ngIf="decimal > 0; else integerInput">
        <mat-form-field class="ag-row fix-mat-form">
            <input #numericInput
                   matInput
                   tabindex="0"
                   type="text"
                   autocomplete="off"
                   [pattern]="PATTERNS.NUMERIC_DECIMAL"
                   [formControl]="formControl"
                   [errorStateMatcher]="matcher">
            <mat-error *ngIf="formControl.hasError('max')">
                {{ 'ValidationErrorMax' | translate: {p0 : max} }}
            </mat-error>
            <mat-error *ngIf="formControl.hasError('min')">
                {{ 'ValidationErrorMin' | translate: {p0 : min} }}
            </mat-error>
        </mat-form-field>
    </ng-container>
    <ng-template #integerInput>
        <mat-form-field class="ag-row fix-mat-form">
            <input #numericInput
                   matInput
                   tabindex="0"
                   type="text"
                   autocomplete="off"
                   [formControl]="formControl"
                   [pattern]="PATTERNS.NUMERIC_INTEGER"
                   [errorStateMatcher]="matcher" />
            <mat-error *ngIf="formControl.hasError('max')">
                {{ 'ValidationErrorMax' | translate: {p0 : max} }}
            </mat-error>
            <mat-error *ngIf="formControl.hasError('min')">
                {{ 'ValidationErrorMin' | translate: {p0 : min} }}
            </mat-error>
        </mat-form-field>
    </ng-template>

</form>
